import base_store from './base'

import auth from './auth'
import router from './router'
import user from './user'

// Load this dynamically in component
// import expenses from './expense'

const modules = [auth, router, user]

const initialize = async () => {
    for (var module of modules) {
        await base_store.register(module)
    }
    return base_store
}

export const initializer = initialize
export const store = base_store
export default store
